import type { Verdict } from '../lib/types';
import { verdictColor } from '../lib/verdict';
import { formatScore } from '../lib/format';
import styles from './ScorePill.module.css';

interface Props {
  verdict: Verdict;
  score?: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function ScorePill({ verdict, score, size = 'md', className }: Props) {
  const c = verdictColor(verdict);
  return (
    <span
      className={[styles.pill, styles[size], className].filter(Boolean).join(' ')}
      style={{ background: c.bg, color: c.fg, borderColor: c.fg }}
    >
      <span className={styles.label}>{verdict}</span>
      {typeof score === 'number' && (
        <span className={styles.score}>{formatScore(score)}</span>
      )}
    </span>
  );
}
